export default __webpack_public_path__ + "5b52f4343421efc1d5e4f66c5a017910.png";